export default "__VITE_ASSET__COzPRyP5__"